
<div mat-dialog-title>Audit Trail<button class="close" mat-button data-cancel-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i>
</button></div>
<mat-dialog-content>
  @if (!data) {
    <mat-card class="block warn">
      <mat-card-title style="white-space: pre-line;"  data-save-edits-message>The changes will be displayed after you save your edits.</mat-card-title>
    </mat-card>
  }
  @if (data) {
    <div class="nameHeader" data-portfolio-name>{{'Portfolio: '+ data.portfolioName}}</div>
    @if (isLoading) {
      <div class="loading-spinner" data-loading-spinner></div>
    }
    @if (!isLoading) {
      <irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "this.defaultGridHeights.height"
        [style.minHeight]="this.defaultGridHeights.minHeight"
        [style.maxHeight]="this.defaultGridHeights.maxHeight"
        [domLayout]="this.defaultGridHeights.domLayout"
        [showSideBar] = "false"
        [gridOptions] = "gridOptions"
        [rowData]="this.pfSumryAuditDTOList"
        [frameworkComponents] = 'frameworkComponents'
      (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    }
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button data-close-button (click)="close()" [ngClass]="data ? 'btn-medium-secondary' : 'btn-medium-primary'">Close
  </button>
  @if (showExport) {
    <button data-export-button (click)="export()" class="btn-medium-primary">Export to Excel</button>
  }
</mat-dialog-actions>
